/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/**
 * This component is used to show more details of a specific template.
 *
 * If this template has images/screenshots, they will be displayed in a carousel
 * If this template has a long description, it will be displayed on a description section bellow the carousel
 *
 * @category ui.components.wizards
 * @exports Showcase
 */
const __vue_script__ = {
    name: 'Showcase',

    props: {
        media: {
            type: Array,
            default: () => []
        },

        close: {
            type: Function,
            default: () => {}
        },

        loading: {
            type: Boolean,
            default: false
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("loader", { attrs: { status: _vm.loading } }, [
    _c("div", { staticClass: "modal-showcase modal-wrapper" }, [
      _c("div", { staticClass: "modal-header" }, [
        _c("span", {
          staticClass: "close",
          on: {
            click: function ($event) {
              return _vm.close()
            },
          },
        }),
        _c("header", [_vm._t("header")], 2),
      ]),
      _c("div", { staticClass: "modal-body" }, [
        _vm.media
          ? _c(
              "section",
              { staticClass: "showcase" },
              [
                _c(
                  "carousel",
                  {
                    attrs: {
                      "per-page": 1,
                      autoplay: true,
                      "pagination-enabled": false,
                      "navigation-enabled": true,
                      "autoplay-timeout": 10000,
                      loop: true,
                    },
                  },
                  _vm._l(_vm.media, function (medium) {
                    return _c("slide", [
                      _c("img", {
                        directives: [
                          {
                            name: "lazy",
                            rawName: "v-lazy",
                            value: medium,
                            expression: "medium",
                          },
                        ],
                        key: medium,
                      }),
                    ])
                  }),
                  1
                ),
              ],
              1
            )
          : _vm._e(),
        _c("section", { staticClass: "details" }, [
          _c(
            "div",
            { staticClass: "description" },
            [_vm._t("main_details")],
            2
          ),
          _c("aside", [_vm._t("side_details")], 2),
        ]),
      ]),
    ]),
  ])
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/modals/Showcase.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__